export enum CmFileInputAccept {
    all = '*/*',
}
